import { privPostRequest } from "../vidCloud/priv";

const RejectedSignatureService = {};

RejectedSignatureService.rejectDocument = (signerGuid, body) => {
  return privPostRequest(`/rejectedsignature/${signerGuid}`, body);
}

export default RejectedSignatureService;